import multiYearLogo from './product-review-multi-year.svg'
import singleYearLogo from './product-review-single-year.svg'
import { defineMessage, useIntl } from 'react-intl'

const productReviewAwardWinnerAlt = defineMessage({
  id: 'dBE4k_X4n-1bnGF6gpyM',
  defaultMessage: 'ProductReview.com.au award winner',
  description: 'Accessibility alt text for the ProductReview.com.au award winner logo',
})

interface Props {
  variant?: 'multi-year' | 'single-year'
  width: string
}

export function ProductReviewLogo({ variant = 'multi-year', width }: Props) {
  const intl = useIntl()
  const src = variant === 'single-year' ? singleYearLogo : multiYearLogo

  return <img src={src} width={width} alt={intl.formatMessage(productReviewAwardWinnerAlt)} />
}
